(function () {
  angular.module("akitabox.ui.dialogs.document.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.document",
    "akitabox.core.toast",
  ]);
})();
